import Types from './cs.types';

export const fetchRateAvrageStart = (timespan) => ({
  type: Types.FETCH_RATES_AVRAGE_START,
  payload: {
    ...timespan,
  },
});
export const fetchCsPercentStart = (timespan) => ({
  type: Types.FETCH_CS_PERCENT_START,
  payload: {
    ...timespan,
  },
});
export const fetchRatesCountStart = (timespan) => ({
  type: Types.FETCH_RATES_COUNT_START,
  payload: {
    ...timespan,
  },
});
export const fetchHappyCustomersStart = (timespan) => ({
  type: Types.FETCH_HAPPY_CUSTOMERS_START,
  payload: {
    ...timespan,
  },
});
export const fetchAngryCustomersStart = (timespan) => ({
  type: Types.FETCH_ANGRY_CUSTOMERS_START,
  payload: {
    ...timespan,
  },
});

export const loadingRatesAvrage = (value) => ({
  type: Types.LOADING_RATES_AVRAGE,
  payload: value,
});

export const loadingCsPercent = (value) => ({
  type: Types.LOADING_CS_PERCENT,
  payload: value,
});

export const loadingRatesCount = (value) => ({
  type: Types.LOADING_RATES_COUNT,
  payload: value,
});
export const loadingHappyCustomers = (value) => ({
  type: Types.LOADING_HAPPY_CUSTOMERS,
  payload: value,
});
export const loadingAngryCustomers = (value) => ({
  type: Types.LOADING_ANGRY_CUSTOMERS,
  payload: value,
});

export const setRatesAvrage = (payload) => ({
  type: Types.SET_RATES_AVRAGE,
  payload,
});

export const setCsPercent = (payload) => ({
  type: Types.SET_CS_PERCENT,
  payload,
});

export const setRatesCount = (payload) => ({
  type: Types.SET_RATES_COUNT,
  payload,
});
export const setHappyCustomers = (payload) => ({
  type: Types.SET_HAPPY_CUSTOMERS,
  payload,
});
export const setAngryCustomers = (payload) => ({
  type: Types.SET_ANGRY_CUSTOMERS,
  payload,
});

export const fetchPlatformsStats = (data) => ({
  type: Types.FETCH_PLATFORMS_STATS_DATA,
  payload: data,
});

export const setPlatformsStatsData = (data) => ({
  type: Types.SET_PLATFORMS_STATS_DATA,
  payload: data,
});

export const setPlatformsStatsLoading = (status) => ({
  type: Types.SET_LOADING_PLATFORMS_STATS,
  payload: status,
});

export const fetchUsersStats = (data) => ({
  type: Types.FETCH_USERS_STATS_DATA,
  payload: data,
});

export const setUsersStatsData = (data) => ({
  type: Types.SET_USERS_STATS_DATA,
  payload: data,
});

export const setUsersStatsLoading = (status) => ({
  type: Types.SET_USERS_STATS_DATA,
  payload: status,
});
